export default "__VITE_ASSET__DwSjgmxx__"